import React from 'react';
import '../css/footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <div className="container">
                <div className="intel">
                    <img className="svg-intelLogo" src="https://resources.liveoptics.com/resources/assets/intel_logo_e831618aaf.svg" alt="" /><span>Innovation Built-In</span>
                </div>
                <span className="copyright">© 2024 Live Optics. All Rights Reserved.</span>
                <div className="links">
                    <ul>
                        <li><a target="_blank" href="https://www.dell.com/learn/uk/en/ukcorp1/policies-privacy-country-specific-privacy-policy" rel="noopener noreferrer">Privacy Statement</a></li>
                        <li><a target="_blank" href="/telemetry" rel="noopener noreferrer">Telemetry Software Notice</a></li>
                        <li><a target="_blank" href="https://app.liveoptics.com/EULA" rel="noopener noreferrer">EULA</a></li>
                        <li><a target="_blank" href="https://www.dell.com/support/search/#q=Live%20Optics&sort=relevancy" className="support-link" rel="noopener noreferrer">Support</a></li>
                        <li><a target="_blank" href="https://www.dell.com/community/en/conversations/search?q=live%20optics" rel="noopener noreferrer">Community</a></li>
                    </ul>
                    <div className="social-icons">
                        <a href="https://twitter.com/runliveoptics" target="_blank" rel="noopener noreferrer"><img className="social-svg" src="https://resources.liveoptics.com/resources/assets/twitter_icon_e351efad5f.svg" alt="" /></a>
                        <a href="https://www.youtube.com/LiveOptics" target="_blank" rel="noopener noreferrer"><img className="social-svg" src="https://resources.liveoptics.com/resources/assets/youtube_icon_ad0d991a32.svg" alt="" /></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;